import type { OperationContextSpec } from "../define"
import { allergenDetectManifest } from "../manifest/allergen-detect"
import { menuDetectMetadataManifest } from "../manifest/menu-detect-metadata"
import { menuTranslateManifest } from "../manifest/menu-translate"
import { productsDetectMetadataManifest } from "../manifest/products-detect-metadata"
import { textGenerateManifest } from "../manifest/text-generate"
import { translateProductsManifest } from "../manifest/translate-products"
import { allergenDetectContextSpec } from "./allergen-detect"
import { menuDetectMetadataContextSpec } from "./menu-detect-metadata"
import { menuTranslateContextSpec } from "./menu-translate"
import { productsDetectMetadataContextSpec } from "./products-detect-metadata"
import { textGenerateContextSpec } from "./text-generate"
import { translateProductsContextSpec } from "./translate-products"

/**
 * Read-side view of the projections. Consumers that only need to validate a
 * persisted context — scope matching, completion effects — resolve the spec by
 * operation type instead of importing one spec per call site, so the version
 * gate is applied uniformly.
 */
export type AnyOperationContextSpec = OperationContextSpec<
	never,
	Record<string, unknown>
>

export const operationContextSpecByType: Record<
	string,
	AnyOperationContextSpec
> = {
	[allergenDetectManifest.type]: allergenDetectContextSpec,
	[menuDetectMetadataManifest.type]: menuDetectMetadataContextSpec,
	[menuTranslateManifest.type]: menuTranslateContextSpec,
	[productsDetectMetadataManifest.type]: productsDetectMetadataContextSpec,
	[textGenerateManifest.type]: textGenerateContextSpec,
	[translateProductsManifest.type]: translateProductsContextSpec,
}

export function contextSpecForOperation(
	type: string,
): AnyOperationContextSpec | undefined {
	return operationContextSpecByType[type]
}
